.trigger {
  display: inline-flex;
  align-items: center;
  position: relative;
}

.triggerButton {
  flex-shrink: 0;
}

.regenerating {
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
}

// Hover popover (portaled to body, positioned via inline style)
.popover {
  position: fixed;
  transform: translateX(-50%);
  width: 320px;
  min-height: 120px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: map.get($radius, 'lg');
  box-shadow:
    0px 2px 4px 0px rgba(0, 0, 0, 0.05),
    0px 10px 30px 0px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  animation: popoverFadeIn 0.2s ease;
  overflow: hidden;

  [data-theme='dark'] & {
    background: rgba(42, 42, 42, 0.95);
  }
}

@keyframes popoverFadeIn {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

// State container (loading, error)
.stateContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 160px;
  gap: map.get($spacing-scale, 'md');
  padding: map.get($spacing-scale, 'lg');
}

.stateText {
  @include body-small-regular;
  color: var(--color-text-tertiary);
  text-align: center;
}

// Image container (loaded state)
.imageContainer {
  position: relative;
}

.imageButton {
  display: block;
  width: 100%;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
}

.gifImage {
  width: 100%;
  display: block;
}

.popoverActions {
  position: absolute;
  top: map.get($spacing-scale, 'xs');
  right: map.get($spacing-scale, 'xs');
  display: flex;
  gap: map.get($spacing-scale, 'xs');
}

.expandButton {
  background: rgba(255, 255, 255, 0.85) !important;
  backdrop-filter: blur(4px);
  border-radius: map.get($radius, 'sm') !important;

  [data-theme='dark'] & {
    background: rgba(42, 42, 42, 0.85) !important;
  }
}

.popoverFooter {
  padding: map.get($spacing-scale, 'xs') map.get($spacing-scale, 'sm');
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid var(--color-border);
}

// Fullscreen modal
.backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: map.get($spacing-scale, 'xl');
  animation: backdropFadeIn 0.2s ease;
}

@keyframes backdropFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal {
  max-width: 900px;
  width: 100%;
  background: var(--color-surface-primary);
  border-radius: map.get($radius, 'lg');
  box-shadow:
    0px 2px 4px 0px rgba(0, 0, 0, 0.05),
    0px 10px 30px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 80px);
  overflow: hidden;
}

.modalHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: map.get($spacing-scale, 'md') map.get($spacing-scale, 'lg');
  border-bottom: 1px solid var(--color-border);
  flex-shrink: 0;
}

.modalTitle {
  @include body-medium;
  color: var(--color-text-primary);
}

.modalContent {
  overflow-y: auto;
  flex: 1;
}

.fullGif {
  width: 100%;
  display: block;
}

.modalFooter {
  display: flex;
  justify-content: flex-end;
  padding: map.get($spacing-scale, 'sm') map.get($spacing-scale, 'lg');
  border-top: 1px solid var(--color-border);
  flex-shrink: 0;
}

// Responsive
@media (max-width: $breakpoint-md) {
  .popover {
    width: 260px;
  }

  .backdrop {
    padding: map.get($spacing-scale, 'md');
  }
}
